import { z } from 'zod';
import { Role } from '../enums';

export const loginSchema = z.object({
  username: z.string().trim().min(3, 'Ingresa tu usuario o correo').max(120),
  password: z.string().min(6, 'La contraseña debe tener al menos 6 caracteres').max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const membershipSchema = z.object({
  companyId: z.string(),
  companyName: z.string(),
  companySlug: z.string(),
  projectId: z.string().nullable(),
  projectName: z.string().nullable(),
  role: z.nativeEnum(Role),
  /** false = empresa oculta: solo la ven sus administradores (para volver a mostrarla). */
  companyActive: z.boolean().default(true),
});
export type Membership = z.infer<typeof membershipSchema>;

export const currentUserSchema = z.object({
  id: z.string(),
  username: z.string(),
  email: z.string(),
  fullName: z.string(),
  isTestAccount: z.boolean(),
  memberships: z.array(membershipSchema),
});
export type CurrentUser = z.infer<typeof currentUserSchema>;

export const authTokensSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number(),
  user: currentUserSchema,
});
export type AuthTokens = z.infer<typeof authTokensSchema>;
